module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("Acknowledgments")])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("First and foremost, I thank my wife, Crystal Kelehear, for proofreading this manuscript many times, for helpful suggestions, and for her excellent figures, which she stayed up until two o’clock in the morning the night before my deadline to finish. She has of course helped in additional innumerable ways and was patient with me while I worked on this. I love her and should give her at least six hugs a day. David Steen provided invaluable assistance in the form of his friendship, library login, and many helpful conversations and encouragements. I want to acknowledge Curtis Callaway, Noah Fields, and Tim Cota, photographers who not only provided outstanding photos but also went “on assignment” to get some of the shots I needed. The rest of the photographers also deserve special recognition for this beautifully illustrated book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks to all the snake biologists who agreed to interviews for this book. Special thanks to my mentors, who taught me everything I know about snakes that the snakes themselves did not teach me: Laine Giovanetto, Harry Greene, Craig Guyer, John Jensen, Gordon Schuett, Rick Shine, David Steen, and Dirk Stevenson. Thanks to J. D. Willson for providing many photos and helpful comments. Rick Shine deserves special mention for his encouragement and for his role in making this book a possibility; his book was the inspiration for mine. I also thank Vincent Burke and others at Johns Hopkins University Press for believing in me, for giving me a chance, and for their editorial guiding hands. My postdoctoral advisor, Tracy Langkilde, and department chair Chris Ritzi deserve mention for allowing me the time to develop and work on the book.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("Finally, thanks to my parents, who indulged and encouraged my love of snakes from an early age.")]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a25ac4ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 78
// module chunks = 0